export const beginViewportLayoutTransition = ({
  cancelScrubFrame,
  hideScrubPreview,
  refreshOverlayLayout,
  scrubActiveRef,
  scrubDisplayPendingRef,
  requestFrame = callback => window.requestAnimationFrame(callback),
  cancelFrame = frameId => window.cancelAnimationFrame(frameId),
}) => {
  cancelScrubFrame();
  scrubActiveRef.current = false;
  scrubDisplayPendingRef.current = false;
  hideScrubPreview();

  let firstFrame = null;
  let settleFrame = null;
  firstFrame = requestFrame(() => {
    firstFrame = null;
    refreshOverlayLayout();
    settleFrame = requestFrame(() => {
      settleFrame = null;
      refreshOverlayLayout();
    });
  });

  return () => {
    if (firstFrame !== null) cancelFrame(firstFrame);
    if (settleFrame !== null) cancelFrame(settleFrame);
  };
};
